import React from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const outerDivStyle = {
    padding: '20px',
    margin: '20px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9'
};

function MobilePrivacyPolicy() {
    const { t } = useTranslation();
  

  return (
    <div style={outerDivStyle}>
      <h1>{t('PrivacyPolicy')}</h1>
      <p>{t('MobileIntro')}</p>
      <h2>{t('InformationWeCollect')}</h2>
      <p>{t('MobileCollectIntro')}</p>
      <ul>
        <li>{t('DeviceInformation')}</li>
        <li>{t('AppUsageData')}</li>
      </ul>
      <h2>{t('FutureReleases')}</h2>
      <p>{t('MobileFutureReleasesIntro')}</p>
      <ul>
        <li>{t('LicenseeInformation')}</li>
      </ul>
      <h2>{t('WhatWeDoNotCollect')}</h2>
      <p>{t('NoCollect')}</p>
      <h2>{t('ChangesToThisPrivacyPolicy')}</h2>
      <p>{t('PolicyChanges')}</p>
      <h2>{t('ContactUs')}</h2>
      <p>{t('ContactIntro')}</p>
      <p>{t('CompanyName')}</p>
      <p>{t('Email')}</p>
      <p>{t('Website')}</p>
    </div>
  );
}

export default MobilePrivacyPolicy;